<script>

export default {
  name: "Dialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    disabledScroll() {
      const body = document.querySelector('uni-page-body')
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      this.scrollTop = scrollTop.toString()
      body.style.position = 'fixed'
      body.style.top = `-${scrollTop}px`
      body.style.bottom = '0'
      setTimeout(() => {
        body.style.overflow = 'hidden';
      }, 300)
    },
    enableScroll() {
      if (this.scrollTop) {
        const body = document.querySelector('uni-page-body')
        body.style.position = ''
        body.style.overflow = ''
        body.style.top = ''
        body.style.bottom = ''
        uni.pageScrollTo({
          scrollTop: this.scrollTop,
          duration: 0
        })
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        // this.disabledScroll()
      } else {
        // this.enableScroll()
      }
    }
  },
}
</script>

<template>
  <u-popup class='dialog' v-model="show" :mode="mode" bgColor="transparent">
    <slot></slot>
  </u-popup>
</template>

<style scoped lang="scss" scoped>

</style>
